import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableSortLabel, TableHead, TableRow, TableBody, useMediaQuery, Theme } from '@mui/material';
import { Order } from 'models/order';
import { OrderItemContext } from 'models/order-item-events';
import ExternalOrderItem from './external-order-item.component';
import { OrderBy } from 'models/search-result';

type ExternalOrderTableProps = {
    orders: Order[];
    hidePatientDetails?: boolean;
    onContextMenu: (orderContext: OrderItemContext) => void;
    setOrderOnField?: (filed: string) => void;
    orderBy?: OrderBy;
    batchActionSelected?: boolean;
    onHandleCheckedOrders?: (order: Order, checked: boolean, orderIndex: number) => void;
    isAtLimit?: boolean;
    checkedOrderIds?: Set<string>;
};
const ExternalOrderTable: FC<ExternalOrderTableProps> = ({
    orders,
    onContextMenu,
    hidePatientDetails,
    setOrderOnField,
    orderBy,
    batchActionSelected,
    onHandleCheckedOrders,
    isAtLimit,
    checkedOrderIds,
}: ExternalOrderTableProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    const sortOrder = (field: string) => {
        if (setOrderOnField) {
            setOrderOnField(field);
        }
    };

    return (
        <Table size={!isLargeScreen ? 'small' : 'medium'}>
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell width="1">{!isMobile ? <span>{translate('common:STATUS')}</span> : undefined}</TableCell>
                    <TableCell>{translate('common:ORDER_ID')}</TableCell>
                    {!hidePatientDetails ? <TableCell>{translate('common:PATIENT')}</TableCell> : undefined}
                    <TableCell>{translate('orders:CONSTRUCTIONS')}</TableCell>
                    <TableCell>
                        <TableSortLabel
                            onClick={() => sortOrder('workFlow.currentStep.dateTime')}
                            active={orderBy?.orderBy === 'workFlow.currentStep.dateTime'}
                            direction={orderBy?.orderDirection}
                        >
                            {translate('common:STEP')}
                        </TableSortLabel>
                    </TableCell>
                    <TableCell>{translate('orders:DELIVERY')}</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            {orders ? (
                <TableBody>
                    {orders.map((order, orderIndex) => (
                        <ExternalOrderItem
                            key={order._id}
                            order={order}
                            hidePatientDetails={hidePatientDetails}
                            onOrderContextMenu={onContextMenu}
                            batchActionSelected={batchActionSelected}
                            onHandleCheckedOrders={onHandleCheckedOrders}
                            orderIndex={orderIndex}
                            isAtLimit={isAtLimit}
                            isChecked={checkedOrderIds?.has(order._id as string) ?? false}
                        />
                    ))}
                </TableBody>
            ) : undefined}
        </Table>
    );
};

export default ExternalOrderTable;
